import { FormPercentageInput } from '@exam-management/components';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Flex,
  Form,
  FormButton,
  FormModal,
  Text,
} from '@shared/components';
import debounce from 'lodash/debounce';
import { useFormContext } from 'react-hook-form';

import type { CheckQSetDuplicationRateFormValues } from '../../types';

interface CheckQSetDuplicationRateFormModalProps {
  open: boolean;
  onClose: () => void;
  onFormSubmit: (formData: CheckQSetDuplicationRateFormValues) => Promise<void>;
}

export default function CheckQSetDuplicationRateFormModal(
  props: Readonly<CheckQSetDuplicationRateFormModalProps>,
) {
  const { open: isOpen, onClose, onFormSubmit } = props;

  const formContext = useFormContext<CheckQSetDuplicationRateFormValues>();
  const {
    formState: { isSubmitting },
  } = formContext;

  const handleClose = () => {
    onClose();
    formContext.reset({ duplicationRate: null as unknown as number });
  };

  const debouncedOnSubmit = debounce(
    async (data: CheckQSetDuplicationRateFormValues) => {
      await onFormSubmit(data);
      handleClose();
    },
    500,
    { leading: true, trailing: true },
  );

  const onSubmit = async (data: CheckQSetDuplicationRateFormValues) => {
    await debouncedOnSubmit(data);
  };

  return (
    <FormModal open={isOpen} onClose={onClose} maxWidth='xs'>
      <Form onSubmit={formContext.handleSubmit(onSubmit)}>
        <DialogTitle onClose={onClose}>Set Duplication Rate</DialogTitle>
        <Divider />
        <DialogContent>
          <Flex
            sx={(theme) => ({ width: '180px', flexDirection: 'column', gap: theme.spacing(1) })}
          >
            <Text variant='body2Semibold'>กำหนดค่าความซ้ำระหว่างชุด</Text>
            <FormPercentageInput name='duplicationRate' textAlign='left' />
          </Flex>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            disabled={isSubmitting}
            color='secondary'
            variant='outlined'
            onClick={handleClose}
          >
            Close
          </Button>
          <FormButton label='Apply' />
        </DialogActions>
      </Form>
    </FormModal>
  );
}
